import { render, staticRenderFns } from "./ThgCheckoutVehicleCard.vue?vue&type=template&id=3eff6f52"
import script from "./ThgCheckoutVehicleCard.vue?vue&type=script&lang=ts"
export * from "./ThgCheckoutVehicleCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports